import React from 'react'

import { Table } from '_zari/core'

import * as Cells from './cells'

const CuentaContableTable = ({ listaCuentasContables }) => {
  return (
    <Table
      filas={listaCuentasContables}
      containerId='cuentas-contables-enlace'
      headRows={[
        {
          label: 'CODIGO'
        },
        {
          label: 'DESCRIPCION'
        },
        {
          label: 'ENLACE'
        },
        {
          label: ''
        }
      ]}
      maxRowsShown={20}
      rowTemplate={(row, k) => (
        <Table.Row key={k}>
          {row.filaVacia ? (
            <>
              <Table.Cell>{'-'}</Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell></Table.Cell>
            </>
          ) : (
            <>
              <Table.Cell>{row.codigoCuenta || '--'}</Table.Cell>
              <Table.Cell>{row.descripcion || '--'}</Table.Cell>
              <Cells.EnlaceCierreClase679Cell row={row} />
            </>
          )}
        </Table.Row>
      )}
    />
  )
}

export default React.memo(CuentaContableTable)
